module.exports = __webpack_public_path__ + "static/media/salt.1798b8ca.svg";